import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Desicion2Component } from '../dialogs/desicion2/desicion2.component';
import { MaterialModule } from 'src/app/material.module';
import { CurrencyDirective } from './directives/currency.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { ciRifDirective } from './directives/ci-rif.directive';
import { NumberPhoneDirective } from './directives/number-phone.directive';
import { RouterModule } from '@angular/router';
import { SuccessComponent } from './components/success/success.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { ComponentValueDirective } from 'src/app/modules/case/componentValue.directive';
import { NotificationItemComponent } from 'src/app/core/components/notificaciones/notification-item/notification-item.component';
import { CreateCaseComponent } from 'src/app/modules/cases/components/create-case/create-case.component';
import { CaseFilesComponent } from 'src/app/modules/cases/components/case-files/case-files.component';
import { CaseFileItemComponent } from 'src/app/modules/cases/components/case-files/case-file-item/case-file-item.component';
import { RemitCaseComponent } from 'src/app/modules/cases/components/remit-case/remit-case.component';
import { AcercadeComponent } from './components/acercade/acercade.component';
import { RasFormComponent } from 'src/app/modules/cases/components/create-case/ras-form/ras-form.component';
import { UsersConectedComponent } from './components/users-conected/users-conected.component';
import { UserConectedCardComponent } from './components/users-conected/user-conected-card/user-conected-card.component';
import { RasNumberComponent } from './components/ras-number/ras-number.component';
import { AutorizarPatronFraudeComponent } from 'src/app/modules/cases/componentsConstants/beforeFinalize/autorizar-patron-fraude/autorizar-patron-fraude.component';
import { SolicitanteInformadoCorreoComponent } from 'src/app/modules/cases/componentsConstants/beforeFinalize/solicitante-informado-correo/solicitante-informado-correo.component';
import { FilterStatusComponent } from 'src/app/modules/cases/components/cases-content/filter-status/filter-status.component';
import { CasesDataPopoverComponent } from 'src/app/modules/cases/components/cases-data-popover/cases-data-popover.component';
import { CaseCardComponent } from 'src/app/modules/cases/components/case-card/case-card.component';
import { FinishCaseComponent } from 'src/app/modules/cases/components/finishCase/finishCase.component';
import { SecondaryInformationComponent } from 'src/app/modules/case/components/secondary-information/secondary-information.component';
import { CaseRecordComponent } from 'src/app/modules/case/components/secondary-information/case-record/case-record.component';
import { CaseCommentComponent } from 'src/app/modules/case/components/secondary-information/case-comment/case-comment.component';
import { CaseFilesRasComponent } from 'src/app/modules/case/components/secondary-information/case-files-ras/case-files-ras.component';
import { RecordItemComponent } from 'src/app/modules/case/components/secondary-information/record-item/record-item.component';
import { CommentItemComponent } from 'src/app/modules/case/components/secondary-information/comment-item/comment-item.component';
import { FileItemComponent } from 'src/app/modules/case/components/secondary-information/file-item/file-item.component';
import { UserIsBlockedPipe } from 'src/app/modules/user/pipes/user-is-blocked.pipe';
import { AddTaskCaseComponent } from 'src/app/modules/case/components/add-task-case/add-task-case.component';
import { TaskService } from 'src/app/modules/case/services/task.service';
import { TaskCaseCardComponent } from 'src/app/modules/case/components/task-case-card/task-case-card.component';
import { SuggestionModalComponent } from './components/suggestion-modal/suggestion-modal.component';
import { FileItemTaskComponent } from 'src/app/modules/case/components/secondary-information/file-item-task/file-item-task.component';
import { ResumeCasePreviewComponent } from 'src/app/modules/case/components/resumeCasePreview/resumeCasePreview.component';
import { FraudeFormComponent } from 'src/app/modules/cases/components/create-case/fraude-form/fraude-form.component';
import { CaseHeaderNewViewComponent } from 'src/app/modules/cases/components/case-header-new-view/case-header-new-view.component';
import { FilterCasesNewViewComponent } from 'src/app/modules/cases/components/case-header-new-view/filter-cases-new-view/filter-cases-new-view.component';
import { NeoVisComponent } from '../dashboard/graph-search/neovis-graph/neovis-graph.component';
import { NeovisModalComponent } from '../dashboard/graph-search/neovis-graph/neovis-graph-modal.component';
import { AlertRecordComponent } from 'src/app/modules/case-new-view/components/alert-record/alert-record.component';
import { AlertRecordItemsComponent } from 'src/app/modules/case-new-view/components/alert-record/alert-record-items/alert-record-items.component';
import { CurrencyMaskDirective } from './directives/currencyMask.directive';
import { NumberRangeDirective } from './directives/number-range.directive';
import { NumberRangeRifDirective } from './directives/number-range-rif.directive';
import { OlnlyLettersDirective } from './directives/olnly-letters.directive';
import { PhoneNumberDirective } from './directives/phone-number.directive';
import { TarjetaValidatorDirective } from './directives/tarjeta-validator.directive';
import { CuentaValidatorDirective } from './directives/cuenta-validator.directive';
import { ApiSlFormRqComponent } from '../dashboard/graph-search/neovis-graph/select-api-sl/api-sl-form-rq/api-sl-form-rq.component';
import { SelectApiSlComponent } from '../dashboard/graph-search/neovis-graph/select-api-sl/select-api-sl.component';
import { KeySlService } from 'src/app/services/key-sl.service';
import { DetailsNodeSlComponent } from '../dashboard/graph-search/graph/details-node-sl/details-node-sl.component';
import { AlertsInProcessAlertComponent } from '../../modules/cases/components/alerts-in-process-alert/alerts-in-process-alert.component';
import { AlertsInProcessModalComponent } from '../../modules/cases/components/alerts-in-process-modal/alerts-in-process-modal.component';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { StrikeAlertUserComponent } from 'src/app/modules/cases/components/strike-alert-user/strike-alert-user.component';
import { StikeUserService } from 'src/app/modules/case-new-view/stike-user.service';
import { MotivoDelReclamoComponent } from '../casos/ver-tarea/components/asuntos-i-e/motivo-del-reclamo/motivo-del-reclamo.component';
import { FileShowViewComponent } from './components/file-show-view/file-show-view.component';
import { FileAudioShowViewComponent } from './components/file-show-view/file-audio-show-view/file-audio-show-view.component';
import { FileDocShowViewComponent } from './components/file-show-view/file-doc-show-view copy/file-doc-show-view.component';
import { FileExcelShowViewComponent } from './components/file-show-view/file-excel-show-view/file-excel-show-view.component';
import { FileImgShowViewComponent } from './components/file-show-view/file-img-show-view/file-img-show-view.component';
import { FilePdfShowViewComponent } from './components/file-show-view/file-pdf-show-view/file-pdf-show-view.component';
import { FileTextShowViewComponent } from './components/file-show-view/file-text-show-view/file-text-show-view.component';
import { FileVideoShowViewComponent } from './components/file-show-view/file-video-show-view/file-video-show-view.component';
import { ModalFileShowViewComponent } from './components/modal-file-show-view/modal-file-show-view.component';
import { InfiniteScrollDirective } from './directives/infiniteScroll.directive';


@NgModule({
  declarations: [
    Desicion2Component,
    CurrencyDirective,
    CurrencyMaskDirective,
    OnlyNumberDirective,
    ciRifDirective,
    NumberPhoneDirective,
    SuccessComponent,
    ConfirmComponent,
    ComponentValueDirective,
    NotificationItemComponent,
    CreateCaseComponent,
    RasFormComponent,
    CaseFilesComponent,
    CaseFileItemComponent,
    RemitCaseComponent,
    AcercadeComponent,
    UsersConectedComponent,
    UserConectedCardComponent,
    RasNumberComponent,
    AutorizarPatronFraudeComponent,
    SolicitanteInformadoCorreoComponent,
    FilterStatusComponent,
    CasesDataPopoverComponent,
    CaseCardComponent,
    FinishCaseComponent,
    SecondaryInformationComponent,
    CaseRecordComponent,
    CaseCommentComponent,
    CaseFilesRasComponent,
    RecordItemComponent,
    CommentItemComponent,
    FileItemComponent,
    UserIsBlockedPipe,
    AddTaskCaseComponent,
    TaskCaseCardComponent,
    SuggestionModalComponent,
    FileItemTaskComponent,
    ResumeCasePreviewComponent,
    FraudeFormComponent,
    CaseHeaderNewViewComponent,
    FilterCasesNewViewComponent,
    NeoVisComponent,
    AlertRecordComponent,
    NeovisModalComponent,
    AlertRecordItemsComponent,
    NumberRangeDirective,
    NumberRangeRifDirective,
    OlnlyLettersDirective,
    PhoneNumberDirective,
    TarjetaValidatorDirective,
    CuentaValidatorDirective,
    ApiSlFormRqComponent,
    SelectApiSlComponent,
    DetailsNodeSlComponent,
    AlertsInProcessAlertComponent,
    AlertsInProcessModalComponent,
    StrikeAlertUserComponent,
    MotivoDelReclamoComponent,
    ModalFileShowViewComponent,
    FileShowViewComponent,
    FileImgShowViewComponent,
    FileAudioShowViewComponent,
    FileVideoShowViewComponent,
    FileTextShowViewComponent,
    FilePdfShowViewComponent,
    FileExcelShowViewComponent,
    FileDocShowViewComponent,
    InfiniteScrollDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    ReactiveFormsModule,
    PdfViewerModule,
  ],
  exports: [
    CurrencyDirective,
    CurrencyMaskDirective,
    NumberRangeDirective,
    NumberRangeRifDirective,
    OlnlyLettersDirective,
    ciRifDirective,
    NumberPhoneDirective,
    PhoneNumberDirective,
    TarjetaValidatorDirective,
    CuentaValidatorDirective,
    SuccessComponent,
    ConfirmComponent,
    ComponentValueDirective,
    NotificationItemComponent,
    CreateCaseComponent,
    RasFormComponent,
    CaseFilesComponent,
    CaseFileItemComponent,
    RemitCaseComponent,
    RasNumberComponent,
    AutorizarPatronFraudeComponent,
    SolicitanteInformadoCorreoComponent,
    FilterStatusComponent,
    CasesDataPopoverComponent,
    CaseCardComponent,
    FinishCaseComponent,
    SecondaryInformationComponent,
    CaseRecordComponent,
    CaseCommentComponent,
    CaseFilesRasComponent,
    RecordItemComponent,
    CommentItemComponent,
    FileItemComponent,
    UserIsBlockedPipe,
    AddTaskCaseComponent,
    TaskCaseCardComponent,
    SuggestionModalComponent,
    FileItemTaskComponent,
    ResumeCasePreviewComponent,
    FraudeFormComponent,
    CaseHeaderNewViewComponent,
    FilterCasesNewViewComponent,
    NeoVisComponent,
    AlertRecordComponent,
    NeovisModalComponent,
    AlertRecordItemsComponent,
    ApiSlFormRqComponent,
    SelectApiSlComponent,
    DetailsNodeSlComponent,
    AlertsInProcessAlertComponent,
    AlertsInProcessModalComponent,
    StrikeAlertUserComponent,
    ModalFileShowViewComponent,
    FileShowViewComponent,
    FileImgShowViewComponent,
    FileAudioShowViewComponent,
    FileVideoShowViewComponent,
    FileTextShowViewComponent,
    FilePdfShowViewComponent,
    FileExcelShowViewComponent,
    FileDocShowViewComponent,
    InfiniteScrollDirective,
  ],
  providers: [TaskService, KeySlService, AlertService, StikeUserService],
})
export class SharedModule {}
